module.exports = __webpack_public_path__ + "img/20-03.6fad6478.png";